

exports.__esModule = true;
exports.$RedirectToCapeRoute = undefined;

require('./directive');

var _squid = require('squid');

var $RedirectToCapeRoute = exports.$RedirectToCapeRoute = _squid.$ComponentRoute.extend('$RedirectToCapeRoute', {

    path: 'redirectToCape',
    directive: 'xo-redirect-to-cape',
    titleContent: 'redirectToCape',
    trackingData: {
        fptiState: 'redirect-to-cape'
    },
    loginRequired: true,
    auth: false,
    children: []
});

angular.value("$RedirectToCapeRoute", $RedirectToCapeRoute);
_squid.$ComponentRoute;


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-credit-components/src/redirect-to-cape/route.js
 ** module id = 489
 ** module chunks = 1
 **/